import { render, staticRenderFns } from "./LoanCreateForm.vue?vue&type=template&id=668ff8e0&scoped=true"
import script from "./LoanCreateForm.vue?vue&type=script&lang=js"
export * from "./LoanCreateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668ff8e0",
  null
  
)

export default component.exports